import React from 'react';
import PropTypes from 'prop-types';

const SelectableButton = ({
  disabled,
  label,
  value,
  name,
  id,
  isSelected,
  onChange
}) => {
  return (
    <div
      className={`selectable-btn ${disabled ? 'selectable-btn-disabled' : ''}`}
    >
      <input
        type="radio"
        id={`${id}`}
        name={name}
        className="selectable-btn_input"
        value={value}
        checked={isSelected}
        onChange={onChange}
      />
      <label className="selectable-btn_label" htmlFor={id}>
        <span>{label}</span>
      </label>
    </div>
  );
};

SelectableButton.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  selected: PropTypes.bool,
  onChange: PropTypes.func
};

export default SelectableButton;
